import React, { Component, PureComponent } from 'react';
import './App.scss';
import ChatPage from './Chats';
import ControlPanel from './ControlPanel';
import TopBar from './Topbar';
import { AppContext } from './Context';
import './i18n';
import Sample from './Sample';
import SideBar from './SideBar';
import Login from './Login';
import { api } from './utils';
import Analytics from './Analytics';
import Loader from './Loader';
import Timer from './utils/Timer';
import Modal from './CommonComponents/Modal';
import Button from './CommonComponents/Button';
import ConfigurationPannel from './ConfigurationPannel';
import LogoutLoader from './assets/icons/logout-loader.gif';
import TenantSelection from './Components/TenantSelection/TenantSelection';
import NoTenant from './Components/TenantSelection/NoTenants';
// import { botID, tabs, BASE_URL } from './constants';
import { ModalBodyIdentifiers } from './constants';
import { type } from 'os';

type Props = {
	t: any;
	i18n: any;
};
type State = {
	available: boolean;
	isLoadingState: boolean;
	// chatMarking:boolean;
	isLoggedIn: boolean;
	selectedTab: number;
	hasSessionExpired: boolean;
	isNetworkDisconnected: boolean;
	toasteVal: string;
	count: number;
	tabName: string;
	defaultroleId: string;
	selectedBotDetails: any;
	calledclearSessionApi: string;
	newTitle: string;
	showLogoutPOpup: boolean;
	fileUploadStatus: {
		[key: string]: {
			file: {
				name: string;
				status: number;
			};
		};
	};
	selectedTenantName: string;
	tenantID: number;
	selectedTenantId: number;
	role: string;
	tenants: any;
	username: string;
	userEmail: string;
	userId: number;
	encryptedUserId: string;
	tenantScreen: boolean;
	showScreen: string;
	hubs: any;
	tenantData: any;
	tenantImageURL: string;
	singleTenant: boolean;
	JSESSIONID: string;
	previousJSESSIONID: string;
	showInvalidate: boolean;
	tenantMutatation: {
		isVisible: boolean;
		modalBodyIdentifier: number;
		tenantAdminErrorMessage?: string;
		tenantInfo: {
			disabled: boolean;
			tenantName: string;
			imageURL: string;
			tenantId: number;
			tenantAdmins?: any;
		};
	};
};
var newTitle;
declare const window: any;

class App extends Component<Props, State> {
	interval: any;

	expiryListener = () => {
		this.setState(
			{
				hasSessionExpired: true,
			},
			() => {
				this.sessionLogout();
				sessionStorage.removeItem('agentLogin');
			}
		);
	};

	constructor(props: Props) {
		super(props);
		this.state = this.setInitialState();
		this.selectTab = this.selectTab.bind(this);
		// this.MakeAgentAvailability=this.MakeAgentAvailability.bind(this);
		this.setLoginStatus = this.setLoginStatus.bind(this);
		this.sfnotifier = this.sfnotifier.bind(this);
		this.sessionLogout = this.sessionLogout.bind(this);
		this.showErrorPopup = this.showErrorPopup.bind(this);
		this.selectedBotDataFromAnalaytics =
			this.selectedBotDataFromAnalaytics.bind(this);
		this.updateFileUploadStatus = this.updateFileUploadStatus.bind(this);
		this.closeFileUploadStatus = this.closeFileUploadStatus.bind(this);
		this.callAvailabilty = this.callAvailabilty.bind(this);
		this.clearSessionInterval = this.clearSessionInterval.bind(this);
		this.redirectionToLoginPage = this.redirectionToLoginPage.bind(this);
		this.decidePath = this.decidePath.bind(this);
		this.changeScreen = this.changeScreen.bind(this);
		this.onUpdateTenants = this.onUpdateTenants.bind(this);
		this.clickedTenant = this.clickedTenant.bind(this);
		this.getTenant = this.getTenant.bind(this);
		this.renderTenantMutationModal = this.renderTenantMutationModal.bind(this);
		this.closeTenantMutatationModal =
			this.closeTenantMutatationModal.bind(this);
		this.setTenantAdminErrorMessage =
			this.setTenantAdminErrorMessage.bind(this);
		this.showTenantAdminModal = this.showTenantAdminModal.bind(this);
		this.callOpenSocket = this.callOpenSocket.bind(this);
		this.clearPreviousSession = this.clearPreviousSession.bind(this);
		// this.showTitleNotification=this.showTitleNotification.bind(this);
		// this.setNotificationInterval=this.setNotificationInterval.bind(this);
		// this.clearNotificationInterval=this.clearNotificationInterval.bind(this);
		// this.showNotification=this.showNotification.bind(this);
	}
	getTenant = () => {
		api(`getTenant`, 'POST', {
			agentSessionID: sessionStorage.getItem('agentActiveSession'),
			agentId: sessionStorage.getItem('agentId'),
		})
			.then((data) => {
				if (data.error === 'Authentication Failed') {
					this.redirectionToLoginPage();
				} else {
					this.setState(
						{
							tenantData: data.response,
						},
						() => {
							this.setLoginStatus(true);
							this.decidePath(
								this.state.tenantData,
								sessionStorage.getItem('firstName') +
									' ' +
									sessionStorage.getItem('lastName')
							);
						}
					);
				}
			})
			.catch(() => {
				const data = {
					response: [
						// {
						//   tenantImageURL: 'null',
						//   role: 'TenantAdmin',
						//   tenantName: 'preprod',
						//   roleId: 2,
						//   tenantId: '81',
						// },
						// {
						//   tenantImageURL: 'null',
						//   role: 'Admin',
						//   tenantName: 'Muthoot',
						//   roleId: 2,
						//   tenantId: '82',
						// },
					],
				};
				// console.log(data.response);
				this.setState(
					{
						tenantData: data.response,
					},
					() => {
						this.setLoginStatus(true);
						this.decidePath(
							this.state.tenantData,
							sessionStorage.getItem('firstName') +
								' ' +
								sessionStorage.getItem('lastName')
						);
					}
				);
			});
	};
	getAllusers = (tenantId: number, cb?: Function) => {
		api(`getAllUsers`, 'POST', {
			tenantId: tenantId,
		})
			.then((data) => {
				if (data.error === 'Authentication Failed') {
					this.redirectionToLoginPage();
				} else {
					this.setState(
						(state) => ({
							tenantMutatation: {
								...state.tenantMutatation,
								tenantInfo: {
									...state.tenantMutatation.tenantInfo,
									tenantAdmins: data.allUsers,
								},
							},
						}),
						() => {
							if (cb) {
								cb();
							}
						}
					);
				}
			})
			.catch(() => {
				const allUsers = {
					allUsers: [
						{
							userId: 281,
							firstName: 'Chitra',
							lastName: 'S',
							userEmail: 'chitra.singaram@senseforth.com',
							dateAdded: '2020-08-02 06:43:50.0',
							lastLoggedin: '2021-12-31 08:34:34.0',
							editable: false,
							roleAssigned: { roleID: 1, role: 'TENANTADMIN' },
						},

						{
							userId: 228,
							firstName: 'Ranganath',
							lastName: 'D',
							userEmail: 'ranganath@senseforth.com',
							dateAdded: '2020-03-09 14:22:50.0',
							lastLoggedin: '2021-12-23 07:53:28.0',
							editable: false,
							roleAssigned: { roleID: 1, role: 'TENANTADMIN' },
						},

						{
							userId: 71,
							firstName: 'Ritesh',
							lastName: '',
							userEmail: 'ritesh@senseforth.com',
							dateAdded: '2018-09-05 14:03:17.0',
							lastLoggedin: '2021-10-22 14:13:41.0',
							editable: false,
							roleAssigned: { roleID: 1, role: 'TENANTADMIN' },
						},
					],
				};
				this.setState(
					(state) => ({
						tenantMutatation: {
							...state.tenantMutatation,
							tenantInfo: {
								...state.tenantMutatation.tenantInfo,
								tenantAdmins: allUsers.allUsers,
							},
						},
					}),
					() => {
						if (cb) {
							cb();
						}
					}
				);
			});
	};
	renderTenantMutationModal = (
		tenantName: string,
		imageURL: string,
		tenantId: number,
		modalBodyIdentifier: number,
		cb?: Function
	) => {
		this.setState(
			(prevState) => ({
				tenantMutatation: {
					// isVisible: false, //changed now newly added
					isVisible: true,
					modalBodyIdentifier,
					tenantInfo: {
						disabled: false,
						tenantName,
						imageURL,
						//tenantId //changed now newly added
						tenantId: tenantId !== 0 ? tenantId : this.state.tenantID,
						tenantAdmins:
							prevState.tenantMutatation.tenantInfo.tenantAdmins || [],
					},
				},
				tenantID: tenantId !== 0 ? tenantId : this.state.tenantID, //newly added
			}),
			() => {
				if (modalBodyIdentifier === ModalBodyIdentifiers.TenantAdmins) {
					this.getAllusers(tenantId, cb);
				}
			}
		);
	};

	showTenantAdminModal = () => {
		this.setState({
			tenantMutatation: {
				isVisible: true,
				modalBodyIdentifier: 1,
				tenantInfo: {
					disabled: false,
					tenantName: '',
					imageURL: '',
					tenantId: this.state.tenantID,
					tenantAdmins: [],
				},
			},
		});
		this.getAllusers(this.state.tenantID);
	};
	componentDidMount() {
		api('PageOnloadGetLoginDetails').then((data) => {
			const {
				result,
				agentId,
				roleId,
				userName,
				userId,
				redirectToLogin,
				error,
			} = data;
			if (result === 'failed') {
				this.redirectionToLoginPage();

				this.setLoginStatus(false);
				sessionStorage.getItem('agentActiveSession');
				sessionStorage.getItem('agentId');
				sessionStorage.getItem('message');
				sessionStorage.getItem('result');
				sessionStorage.getItem('roleId');
				sessionStorage.getItem('userName');
				sessionStorage.getItem('userId');
			} else {
				// if (redirectToLogin === true) {
				// 	this.redirectionToLoginPage();
				// } else {
				Timer.start(10, 'min');

				sessionStorage.setItem('agentId', agentId);
				sessionStorage.setItem('result', result);
				sessionStorage.setItem('userName', userName);
				sessionStorage.setItem('userId', userId);
				sessionStorage.setItem('currentSessionID', '');
				sessionStorage.setItem('startsessionID', '');
				sessionStorage.setItem('botsessionID', '');
				this.getTenant();
				// }
			}
		});
	}

	componentWillUnmount() {
		document.removeEventListener('sessionexpire', this.expiryListener);
		document.title = 'Hybrid Dashboard';
		this.clearSessionInterval();
	}
	callOpenSocket() {
		let requestObj = {
			oldSessionID: this.state.previousJSESSIONID,
			newSessionID: this.state.JSESSIONID,
		};
		api(`openSocket`, 'POST', requestObj)
			.then((data) => {
				if (data.result === 'Success') {
					// console.log('Newly Opened the failed socket');
					document.dispatchEvent(new CustomEvent('socketFailOpen'));
				}
			})
			.catch((e) => {
				console.log(e);
			});
	}
	componentDidUpdate() {
		if (this.state.isLoggedIn) {
			this.checkTimer();
		}
		if (this.state.singleTenant) {
			this.setState({
				selectedTab: this.state.tenantData[0].roleId === 3 ? 1 : 0,
				singleTenant: false,
			});
		}

		// window.addEventListener('online', () =>

		//    this.networkStatusChangeHandler(false)
		// );
		// window.addEventListener('offline', () =>
		//    this.networkStatusChangeHandler(true)
		// );
	}

	networkStatusChangeHandler = (isConnectedToNetwork: boolean) => {
		if (isConnectedToNetwork === true) {
			this.setState(
				{
					showLogoutPOpup: isConnectedToNetwork,
				},
				() => {
					this.sessionLogout();
					sessionStorage.removeItem('agentLogin');
					document.title = 'Hybrid Dashboard';
				}
			);
		} else {
			this.setState({
				showLogoutPOpup: isConnectedToNetwork,
			});
		}
	};

	clearSessionInterval() {
		clearInterval(window.setSessionInterval);
	}

	setInitialState(): State {
		let roleId = sessionStorage.getItem('roleId');
		return {
			// selectedTab: roleId === '3' ? 1 : 0, //changed for now
			selectedTab: -1,
			isLoggedIn: false,
			hasSessionExpired: false,
			isNetworkDisconnected: false,
			toasteVal: '',
			count: 0,
			tabName: '',
			defaultroleId: '',
			selectedBotDetails: [
				{
					botid: '',
					botIconUrl: '',
					botName: '',
					baseURL: '',
				},
			],
			calledclearSessionApi: '',
			fileUploadStatus: {},
			available: false,
			// chatMarking:false,
			newTitle: '',
			isLoadingState: false,
			showLogoutPOpup: false,
			selectedTenantName: '',
			selectedTenantId: 0,
			tenantID: 0,
			role: '',
			tenants: [],
			username: '',
			userEmail: '',
			userId: 0,
			encryptedUserId: '',
			tenantScreen: false,
			// showScreen: 'HybridScreen', //changed for now
			showScreen: '',
			hubs: {},
			tenantData: [],
			tenantImageURL: '',
			singleTenant: false,
			JSESSIONID: '',
			previousJSESSIONID: '',
			showInvalidate: false,
			tenantMutatation: {
				isVisible: false,
				modalBodyIdentifier: 1,
				tenantAdminErrorMessage: '',
				tenantInfo: {
					disabled: false,
					tenantName: '',
					imageURL: '',
					tenantId: 0,
					tenantAdmins: [],
				},
			},
		};
	}

	// componentDidUpdate(){
	//   newTitle = '';
	// }

	// setNotificationInterval(fn:string,time:number){
	//    this.interval=setInterval(()=>{

	//     if(document.title==='Hybrid Dashboard'){
	//       this.showTitleNotification(fn)
	//     }
	//     else{
	//       document.title='Hybrid Dashboard'
	//     }
	//     },time)
	// }
	// clearNotificationInterval(){
	//   clearInterval(this.interval)
	// }
	// showNotification(notificationMessage: string, name: string) {
	//   // console.log("notify",notificationMessage)
	//     new Notification(`New chat in ${"‘"+notificationMessage+"’"} queue`, {

	//       // body:`New chat in ${notificationMessage} queue`+'\r\n'+`${name} is waiting for an agent `
	//       body:`${name} is waiting for an agent `
	//     });
	//     const audio = document.querySelector('#my_new_audio') as HTMLAudioElement;
	//     audio.play();

	// }
	//   showTitleNotification(sender: string) {
	//      newTitle=sender + ' says...';
	//     document.title ='Hybrid Dashboard'
	//     document.title = newTitle;

	//   }
	closeTenantMutatationModal = () => {
		this.setState({
			tenantMutatation: {
				isVisible: false,
				modalBodyIdentifier: 0,
				tenantInfo: {
					disabled: false,
					tenantName: '',
					imageURL: '',
					tenantId: 0,
				},
			},
		});
	};
	setTenantAdminErrorMessage = (tenantAdminErrorMessage: any) => {
		this.setState((prevState) => ({
			tenantMutatation: {
				...prevState.tenantMutatation,
				tenantAdminErrorMessage,
				tenantAdminProcessing: true,
			},
		}));
	};
	selectTab(index: number, name: string) {
		this.setState({
			selectedTab: index,
			tabName: name,
		});
	}
	sfnotifier(val: string) {
		this.setState({
			toasteVal: val,
			count: this.state.count + 1,
		});
	}

	onUpdateTenants = (tenants: any, username: any, callback: any) => {
		this.setState(
			{
				tenants,
				username,
			},
			callback
		);
	};
	clickedTenant = (data: any) => {
		sessionStorage.setItem('roleId', data.roleId);
		this.setState({
			tenantID: data.tenantId,
			role: data.role,
			selectedTenantName: data.tenantName,
			tenantImageURL: data.tenantImageURL,
			showScreen: 'HybridScreen',
			defaultroleId: data.roleId ? data.roleId : '',
			selectedTab: data.roleId === 3 ? 1 : 0,
		});
	};

	decidePath(tenants: any, username: any) {
		if (tenants.length === 1) {
			sessionStorage.setItem('roleId', tenants[0].roleId);
			sessionStorage.setItem('showScreen', 'HybridScreen');
			this.setState({
				showScreen: 'HybridScreen',
			});
		}
		this.setState(
			{
				tenants,
				username,
			},
			() => {
				if (tenants.length === 1) {
					// this.onSetTenant(tenants[0].tenantId);
					// console.log(tenants[0].tenantId)
					sessionStorage.setItem('roleId', tenants[0].roleId);

					this.setState(
						{
							tenantID: tenants[0].tenantId,
							role: tenants[0].role,
							selectedTenantName: tenants[0].tenantName,
							tenantImageURL: tenants[0].tenantImageURL,
							showScreen: 'HybridScreen',
							defaultroleId: tenants[0].roleId ? tenants[0].roleId : '',
							selectedTab: tenants[0].roleId === 3 ? 1 : 0,
							singleTenant: true,
						},
						() => {
							this.setLoginStatus(true);
						}
					);
				} else if (tenants.length === 0) {
					sessionStorage.setItem('showScreen', 'NoTenant');
					this.setState({
						showScreen: 'NoTenant',
					});
				} else {
					sessionStorage.setItem('showScreen', 'TenantSelection');
					this.onUpdateTenants(tenants, username, () =>
						this.setState({
							showScreen: 'TenantSelection',
						})
					);
				}
			}
		);
	}
	setLoginStatus(bool: boolean) {
		this.setState(
			{
				isLoggedIn: bool,
				// defaultroleId: roleId ? roleId : '', //newly commented
				// selectedTab: roleId === '3' ? 1 : 0,
			},
			() => {
				if (this.state.isLoggedIn === false) {
					this.setState(
						{
							hasSessionExpired: false,
						},
						() => {
							document.removeEventListener(
								'sessionexpire',
								this.expiryListener
							);
						}
					);
				} else {
					window['setSessionInterval'] = setInterval(() => {
						api(`SessionKeepAlive`, 'POST', {
							isAgent: true,
							agentId: sessionStorage.getItem('agentId'),
						}).then((res) => {
							if (res.error === 'Authentication Failed') {
								this.redirectionToLoginPage();
							} else {
								// if (res.redirectToLogin === true) {
								// 	this.redirectionToLoginPage();
								// } else {
								this.setState(
									(prevState) => {
										return {
											JSESSIONID: res.curSessId,
											previousJSESSIONID: prevState.JSESSIONID,
										};
									},
									() => {
										// console.log(
										//   'previous session' + this.state.previousJSESSIONID,
										//   'current session' + this.state.JSESSIONID
										// );
										if (
											this.state.JSESSIONID !== this.state.previousJSESSIONID &&
											this.state.previousJSESSIONID !== ''
										) {
											this.callOpenSocket();
										}
									}
								);
							}
						});
					}, 30000);
				}
			}
		);
	}
	changeScreen(screen: string) {
		sessionStorage.setItem('showScreen', screen);
		this.setState(
			{
				showScreen: screen,
			},
			() => {
				// if (screen === 'TenantSelection') {
				//   console.log('tenant selection');
				//   document.dispatchEvent(new CustomEvent('socketClose'));
				// }
			}
		);
	}

	checkTimer() {
		document.addEventListener('sessionexpire', this.expiryListener);
	}
	selectedBotDataFromAnalaytics(botData: any) {
		this.setState({
			selectedBotDetails: [
				{
					botid: botData.botid,
					botIconUrl: botData.botIconUrl,
					botName: botData.botName,
					baseURL: botData.baseURL,
				},
			],
		});
	}

	redirectionToLoginPage() {
		// this.setState(
		//   {
		//     calledclearSessionApi: 'called',
		//     isLoggedIn: false,
		//   },
		//   () => {
		//     sessionStorage.removeItem('agentLogin');
		//     sessionStorage.removeItem('roleId');
		//     sessionStorage.removeItem('wsConnendpoint');
		//     sessionStorage.removeItem('websocketendpoint');
		//     sessionStorage.removeItem('autoassignOnLoginCalled');
		//     sessionStorage.removeItem('agentId');
		//     sessionStorage.removeItem('roleId');

		//     document.title = 'Hybrid Dashboard';
		//     this.clearSessionInterval();
		//   }
		// );
		this.setState(
			{
				showInvalidate: true,
			},
			() => {
				this.sessionLogout();
				document.title = 'Hybrid Dashboard';
			}
		);
	}
	clearPreviousSession() {
		this.setState({
			previousJSESSIONID: '',
			JSESSIONID: '',
		});
	}
	async sessionLogout() {
		//  if (this.state.calledclearSessionApi !== 'called') {
		if (sessionStorage.getItem('agentId')) {
			const response = await api(`clearSessionForAgent`, 'POST', {
				user: 'agent',
				agentSessionID: sessionStorage.getItem('agentActiveSession'),
				agentId: sessionStorage.getItem('agentId'),
			}).then((res) => {
				document.dispatchEvent(new CustomEvent('socketClose'));
				this.clearSessionInterval();
				// this.setState({
				//   calledclearSessionApi: 'called',
				//   isLoggedIn: false,
				// });
				this.setState(
					{
						calledclearSessionApi: 'called',
						isLoggedIn: false,
						previousJSESSIONID: '',
						JSESSIONID: '',
					},
					() => {
						sessionStorage.removeItem('agentLogin');
						sessionStorage.removeItem('roleId');
						sessionStorage.removeItem('wsConnendpoint');
						sessionStorage.removeItem('websocketendpoint');
						sessionStorage.removeItem('autoassignOnLoginCalled');
						sessionStorage.removeItem('agentId');
						sessionStorage.removeItem('roleId');
						sessionStorage.removeItem('agentActiveSession');

						document.title = 'Hybrid Dashboard';
					}
				);
			});

			return response;
		}
	}

	updateFileUploadStatus(sessionID: string, name: string, status: number) {
		this.setState({
			fileUploadStatus: {
				...this.state.fileUploadStatus,
				[sessionID]: {
					file: {
						name,
						status,
					},
				},
			},
		});
	}

	//  chatChangeAvailable=(d:boolean)=>{
	//   this.setState({
	//     chatMarking:d
	//  },()=>{
	//  })
	//  }

	setLogoutLoading = (load: boolean) => {
		this.setState({
			isLoadingState: load,
		});
	};
	callAvailabilty = (data: boolean) => {
		this.setState({
			available: data,
		});
	};
	// MakeAgentAvailability = (val: boolean) => {

	//   api(`markAgentAvailibility`, 'POST', {
	//     loggedInAgentId: sessionStorage.getItem('agentId'),
	//     isAgentAvailable: val,
	//   }).then((res) => {
	//     api(
	//       `getMarkedAgentAvailibility?loggedInAgentId=${sessionStorage.getItem('agentId')}`
	//     ).then((res) => {
	//     });
	//   });

	// };

	closeFileUploadStatus(sessionID: string) {
		this.setState((prevState: State) => {
			return {
				...prevState,
				fileUploadStatus: {
					...prevState.fileUploadStatus,
					[sessionID]: undefined,
				},
			} as State;
		});
	}
	showErrorPopup(vals: boolean) {
		this.setState({
			showLogoutPOpup: vals,
		});
	}
	render() {
		return (
			<AppContext.Consumer>
				{(val) => {
					return (
						<>
							{this.state.isLoggedIn ? (
								<div>
									<TopBar
										setStatus={this.setLoginStatus}
										toasterVal={this.state.toasteVal}
										countforToaster={this.state.count}
										setLogoutLoading={this.setLogoutLoading}
										clearSessionInterval={this.clearSessionInterval}
										tenants={this.state.tenants}
										changeScreen={this.changeScreen}
										showScreen={this.state.showScreen}
										role={this.state.role}
										tenantId={this.state.tenantID}
										selectedTenantName={this.state.selectedTenantName}
										tenantImageURL={this.state.tenantImageURL}
										getTenant={this.getTenant}
										renderTenantMutationModal={this.renderTenantMutationModal}
										closeTenantMutatationModal={this.closeTenantMutatationModal}
										setTenantAdminErrorMessage={this.setTenantAdminErrorMessage}
										showTenantAdminModal={this.showTenantAdminModal}
										tenantMutatation={this.state.tenantMutatation}
										getAllusers={this.getAllusers}
										clearPreviousSession={this.clearPreviousSession}
									/>
									<div id='__main__'>
										{this.state.showScreen === 'TenantSelection' ? (
											<TenantSelection
												tenants={this.state.tenants}
												changeScreen={this.changeScreen}
												clickedTenant={this.clickedTenant}
												renderTenantMutationModal={
													this.renderTenantMutationModal
												}
											/>
										) : //  :  //we are not handling no tenant and hub .Its for future purpose
										this.state.showScreen === 'NoTenant' ? (
											<NoTenant
											// tenants={this.state.tenants}
											/>
										) : (
											// this.state.showScreen==="MyHub" ?
											// <MyHub
											// botList={data.botList}
											// myHubUserList={0}
											// changeScreen={this.changeScreen}
											// />
											<>
												<SideBar
													selectedTab={this.state.selectedTab}
													selectTab={this.selectTab}
													tabName={this.state.tabName}
												/>
												<GetPage
													t={this.props.t}
													selectedTab={this.state.selectedTab}
													dispatch={val.dispatch}
													sfNotify={this.sfnotifier}
													tabName={this.state.tabName}
													defaultroleId={this.state.defaultroleId}
													selectedBotDataFromAnalaytics={
														this.selectedBotDataFromAnalaytics
													}
													selectedBotDetails={this.state.selectedBotDetails}
													fileUploadStatus={this.state.fileUploadStatus}
													updateFileUploadStatus={this.updateFileUploadStatus}
													closeFileUploadStatus={this.closeFileUploadStatus}
													// MakeAgentAvailability={this.MakeAgentAvailability}
													callAvailabilty={this.callAvailabilty}
													available={this.state.available}
													redirectionToLoginPage={this.redirectionToLoginPage}
													showScreen={this.state.showScreen}
													tenantId={this.state.tenantID}
													role={this.state.role}
													// chatMarking={this.state.chatMarking}
													// chatChangeAvailable={this.chatChangeAvailable}
												/>
											</>
										)}
									</div>
								</div>
							) : (
								<div
									style={!this.state.isLoadingState ? {} : { display: 'none' }}>
									<Login
										setStatus={this.setLoginStatus}
										showErrorPopup={this.showErrorPopup}
										decidePath={this.decidePath}
										getTenant={this.getTenant}
									/>
								</div>
							)}
							{this.state.isLoadingState ? (
								<div
									className='logout-loader'
									style={{
										width: '100%',
										height: '100%',
									}}>
									<div className='logout-inner'>
										<img
											src={LogoutLoader}
											alt='loader'
											className='loader-icon'
										/>
										<span className='loader-content'>Logging you out</span>
									</div>
								</div>
							) : null}
							<Loader show={val.isLoading} />
							<Modal
								style={{ zIndex: 10001 }}
								isOpen={this.state.hasSessionExpired}
								title='Notice'
								onClose={() => {
									this.setState({
										isLoggedIn: false,
										hasSessionExpired: false,
									});
								}}>
								<div id='session-expiry-wrapper'>
									Your session has expired. Please login again to continue.
									<Button
										text='Confirm'
										theme='dark'
										onClick={() => {
											this.setState({
												isLoggedIn: false,
												hasSessionExpired: false,
											});
										}}
									/>
								</div>
							</Modal>

							{/* <Modal
								style={{ zIndex: 10001 }}
								isOpen={this.state.showLogoutPOpup}
								title='Network'
								// title='Notice'
								onClose={() => {
									this.setState({
										isLoggedIn: false,
										showLogoutPOpup: false,
									});
								}}>
								<div id='network-disconnected-wrapper'>
									You are already logged in to Hybrid Chat from another device
									or browser. Please logout from the other device or browser to
									use Hybrid Chat here.
									<Button
										text='Okay'
										theme='take-over-chat'
										onClick={() => {
											this.setState({
												isLoggedIn: false,
												showLogoutPOpup: false,
											});
										}}
									/>
								</div>
							</Modal> */}
							<Modal
								style={{ zIndex: 10001 }}
								isOpen={this.state.showInvalidate}
								title='Notice'
								onClose={() => {
									this.setState({
										showInvalidate: false,
									});
								}}>
								<div id='session-expiry-wrapper'>
									Your session is invalidated due to new session started in
									other device or browser.
									{/* Your session invalidated. Someone loggedin into your account . */}
									<Button
										text='Okay'
										theme='dark'
										onClick={() => {
											this.setState({
												showInvalidate: false,
											});
										}}
									/>
								</div>
							</Modal>
						</>
					);
				}}
			</AppContext.Consumer>
		);
	}
}
export default App;

const GetPage = (props: any) => {
	// if(props.selectedTab===0 && props.available===true){
	//   if(props.chatMarking===true){
	//     props.MakeAgentAvailability(true);
	//   }
	//   else{
	//     props.MakeAgentAvailability(false);
	//   }

	// }
	// else if(props.selectedTab!==0){

	//   props.MakeAgentAvailability(false);
	// }

	switch (props.selectedTab) {
		case 0:
			return (
				<ChatPage
					toasterNotifier={props.sfNotify}
					fileUploadStatus={props.fileUploadStatus}
					updateFileUploadStatus={props.updateFileUploadStatus}
					closeFileUploadStatus={props.closeFileUploadStatus}
					redirectionToLoginPage={props.redirectionToLoginPage}
					showScreen={props.showScreen}
					tenantId={props.tenantId}
					// MakeAgentAvailability={props.MakeAgentAvailability}
					// callAvailabilty={props.callAvailabilty}
					// available={props.available}
					// chatMarking={props.chatMarking}
					// chatChangeAvailable={props.chatChangeAvailable}
					// showTitleNotification={props.showTitleNotification}
					// setNotificationInterval={props.setNotificationInterval}
					// clearNotificationInterval={props.clearNotificationInterval}
					// showNotification={props.showNotification}
				/>
			);
		case 1:
			return (
				<Analytics
					toasterNotifier={props.sfNotify}
					dispatch={props.dispatch}
					selectedBotDataFromAnalaytics={props.selectedBotDataFromAnalaytics}
					redirectionToLoginPage={props.redirectionToLoginPage}
					tenantId={props.tenantId}
					// MakeAgentAvailability={props.MakeAgentAvailability}
					// callAvailabilty={props.callAvailabilty}
				/>
			);
		case 2:
			return (
				<ConfigurationPannel
					toasterNotifier={props.sfNotify}
					selectedBotDetails={props.selectedBotDetails}
					redirectionToLoginPage={props.redirectionToLoginPage}
					tenantId={props.tenantId}
					role={props.role}
					// MakeAgentAvailability={props.MakeAgentAvailability}
					// callAvailabilty={props.callAvailabilty}
				/>
			);
		case 3:
			return <Sample />;
		default:
			return null;
	}
};
